/** Twilio connection statuses treated as inactive for participant counts and UI. */
export const CALL_CONNECTION_STATUSES_TO_IGNORE = [
  'failed',
  'busy',
  'no-answer',
  'canceled',
] as const;
